/**
 * Tab directive
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 30.01.2015-14:41
 */

lmApp.
  directive('lmTabs', ['$timeout', '$location', '$rootScope', 'AdministrationService',
    function ($timeout, $location, $rootScope, AdministrationService) {
      return {
        templateUrl: 'lm-tabs/tabs.tpl.html',
        restrict: 'E',
        replace: true,
        link: function (scope, element, attrs) {
          scope.tabsData = {};
          scope._tab_element_ = element;
          scope._window_ = angular.element(window);

          var _onResize = function() {
            if (!$rootScope.isMenuManual) {
              if (scope._window_.width() < 988 && scope.isOpen()) {
                $timeout(function () {
                  $rootScope.isMenuOpen = false;
                });
              } else if (scope._window_.width() >= 988 && !scope.isOpen()) {
                $timeout(function () {
                  $rootScope.isMenuOpen = true;
                });
              }
            }


          };

          var _buildServices = function (services) {
            var services = services || [];
            var apps = services.filter(function (service) {
              return service.name.indexOf('app.stockweb') !== -1;
            });

            if ('sections' in scope.tabsData.tabs['application'] === false) {
              scope.tabsData.tabs['application'].sections = {};
            }

            _.forEach(apps, function (service) {
              scope.tabsData.tabs['application'].sections[service.name.replace('app.', '')] = {
                title: $rootScope._getServiceName(service),
                route: '/application/' + service.name.replace('app.', ''),
                mode: scope.tabsData.tabs['application'].mode,
                icon: $rootScope._getServiceIcon(service)
              };
            });

            //if (apps && apps.length) {
              scope.tabsData.tabs['application'].sections['banners-ng'] = {
                title: 'Banners',
                route: '/application/banners-ng',
                mode: scope.tabsData.tabs['application'].mode,
                icon: 'panorama'
              }
              scope.tabsData.tabs['application'].sections['rails'] = {
                title: 'UI Editor',
                route: '/application/rails',
                mode: scope.tabsData.tabs['application'].mode,
                icon: 'view-quilt'
              }
            //}
          };

          scope.getStyle = function () {

            return {
              height: element.find('.menu-wrapper').height()
            }
          };

          angular.element(window).bind('resize', _onResize);

          scope.tabsData = {
            isOver: false,
            tabs: {},
            init: function () {
              var locationPath = $location.path();
              var path = locationPath.split('/');

              var tab = _.find(scope.tabsData.tabs, {route: '/' + path[1]});

              if (tab) {
                scope.tabsData.activeTab = tab;

                if (tab.sections) {
                  var subTab = _.find(tab.sections, function (item) {
                    return locationPath.indexOf(item.route) !== -1;
                  });

                  if (subTab) {
                    scope.tabsData.activeSubTab = subTab;
                    $rootScope.currentRoute = subTab.title;
                  } else {
                    scope.tabsData.activeSubTab = tab.sections[0];
                    $rootScope.currentRoute = tab.title;
                  }
                }
              } else {
                scope.tabsData.activeTab = {};
                scope.tabsData.activeSubTab = {};
              }
            },
            setActiveTab: function (tab) {
              if (tab.sections) {
                tab.isExpand = !tab.isExpand;
              } else {
                scope.tabsData.activeTab = tab;
                scope.tabsData.activeSubTab = {};
                $rootScope.go(tab.route);
              }
            },
            setActiveSubTab: function (tab) {
              scope.tabsData.activeSubTab = tab;

              $rootScope.go(tab.route);
            },
            activeTabIndex: -1,
            activeTab: {}
          };

          scope.isOpen = function () {
            return !!$rootScope.isMenuOpen;
          };

          scope.close = function () {
            $timeout(function () {
              $rootScope.isMenuOpen = false;
            });
          };

          scope.tabsData.tabs = AdministrationService.GetParseAccountPermissions();

          if ($rootScope._self && $rootScope._self.services) {
            if (scope.tabsData.tabs['application'].mode !== 'none') {
              _buildServices($rootScope._self.services);
            }

/*            if (!_.find($rootScope._self.services, {name: 'catchup2'})) {
              scope.tabsData.tabs['epg'].sections['catchup-2-0'].mode = 'none';
            }*/
          }

          scope.$on('location:change', function (event, data) {
            var tab = _.find(scope.tabsData.tabs, {route: '/' + data.split('/')[1]});
            if (tab) {
              scope.tabsData.activeTab = tab;

              if (tab.sections) {
                var subTab = _.find(tab.sections, {route: data});

                if (subTab) {
                  scope.tabsData.activeSubTab = subTab;
                  $rootScope.currentRoute = subTab.title;
                } else {
                  scope.tabsData.activeSubTab = {};
                  $rootScope.currentRoute = tab.title;
                }
              }
            } else {
              scope.tabsData.activeTab = {};
              scope.tabsData.activeSubTab = {};
              $rootScope.currentRoute = '';
            }
          });

          scope.$on('self:update', function (event, data) {

            $timeout(function () {
              scope.tabsData.tabs = AdministrationService.GetParseAccountPermissions();

              if (scope.tabsData.tabs['application'].mode !== 'none') {
                _buildServices(data.services);
              }

              if (_.find(data.services, {name: 'catchup2'})) {
                scope.tabsData.tabs['epg'].sections['catchup-2-0'] = {
                  title: 'Catchup 2.0',
                  route: '/epg/catchup-2-0',
                  mode: 'rw',
                  icon: 'video-switch'
                }
              } else {
                //scope.tabsData.tabs['epg'].sections['catchup-2-0'].mode = 'none';
              }
            });


          });


          $timeout(function () {
            scope.tabsData.init();
            _onResize();
          });

          scope.$on('$destroy', function () {
            angular.element(window).unbind('resize', _onResize);
          });
        }
      };
    }]);
